module.exports = __webpack_public_path__ + "img/side-icon-41.4651a806.svg";